import dayjs from 'dayjs';

// Format date string (e.g., ISO string) to a user-friendly format
export const formatDate = (dateString: string | undefined | null, format = 'D MMM YYYY'): string => {
  if (!dateString) return 'N/A';
  return dayjs(dateString).format(format);
};

// Format numbers for display (e.g., with commas)
export const formatNumber = (num: number | undefined | null): string => {
  if (num === null || num === undefined) return '0'; // Or 'N/A'
  return num.toLocaleString();
};

// Format currency values with dollar sign
export const formatCurrency = (amount: number | undefined | null): string => {
  if (amount === null || amount === undefined) return '$0.00';
  return `$${amount.toLocaleString('en-US', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  })}`;
}; 